import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { API } from 'api';
import { apiName, apiBasePath } from 'assets/constants';

import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

export async function getActionPlanDetail(
  kitId: string,
  actionId: string | number,
) {
  const response = await API.get(
    apiName,
    `${apiBasePath}/actionplan/v5/${kitId}/action/${actionId}`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.ACTION_PLAN,
        domain: DOMAINS.ACTION_PLAN,
        importance: IMPORTANCE.HIGH,
      },
      context: {
        kitId,
        actionId,
      },
    },
  );
  return response?.result;
}

const getActionPlanItemQueryKey = (
  kitId: string | null,
  actionId: string | number,
) => ({
  queryKey: [apiName, 'actionPlanItem', 'v5', kitId, String(actionId)],
  queryFn: () => kitId && actionId && getActionPlanDetail(kitId, actionId),
});

export const useActionPlanItemNonSuspense = ({
  kitId,
  actionId,
  enabled = true,
}: {
  kitId?: string | null;
  actionId?: string | number;
  // Prefetch warms the cache for same-tab navigation; disable it when the
  // card opens in a new tab (fresh app instance, won't share this cache).
  enabled?: boolean;
}) => {
  const actionPlanItemQuery = useQuery({
    ...getActionPlanItemQueryKey(kitId ?? null, actionId ?? ''),
    enabled,
  });
  return actionPlanItemQuery;
};

const useActionPlanItem = ({
  kitId,
  actionId,
}: {
  kitId?: string | null;
  actionId?: string | number;
}) => {
  const actionPlanItemQuery = useSuspenseQuery(
    getActionPlanItemQueryKey(kitId ?? null, actionId ?? ''),
  );
  return actionPlanItemQuery;
};

export default useActionPlanItem;
